export default "__VITE_ASSET__D32lXHYR__"